import React from 'react';

// Components
import SingleCheckboxInputComponent from './SingleCheckboxInputComponent';

// Types
import { FlowsQuestion } from '../../../../types/FlowsTypes';
interface Props {
  question: FlowsQuestion;
}

const SingleCheckboxInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  ...otherProps
}) => {
  switch (null) {
    default:
      return <SingleCheckboxInputComponent {...otherProps} />;
  }
};

export default SingleCheckboxInputPicker;
